import axios from 'axios'

import { URL_PREFIX } from '../config'

export const getAllArtworkExhibitions = () => {
  return axios.get(URL_PREFIX + '/artwork-exhibitions/')
}

export const getArtworkExhibition = (id) => {
  return axios.get(URL_PREFIX + '/artwork-exhibitions/' + id + '/')
}

export const postArtworkExhibition = (param) => {
  return axios.post(URL_PREFIX + '/artwork-exhibitions/', param)
}

export const putArtworkExhibition = (id, param) => {
  return axios.put(URL_PREFIX + '/artwork-exhibitions/' + id + '/', param)
}

export const deleteArtworkExhibition = (id) => {
  return axios.delete(URL_PREFIX + '/artwork-exhibitions/' + id + '/')
}
